// This enum defines the keys used to emit events related to speed test status and results.
export enum SpeedTestEmitterKey {
	STATUS = 'status',
	DOWNLOAD_SPEED = 'downloadSpeed',
	UPLOAD_SPEED = 'uploadSpeed',
}
